<script>
import Builder from "@src/forms/form-builder";
import Provider from "@src/forms/provider-consultaCobertura";

import telefone from "@src/forms/schemas/telefone";
import cep from "@src/forms/schemas/cep";
import numero from "@src/forms/schemas/numero";
import leadSource from "@src/forms/schemas/leadSource";
import vendedor from "@src/forms/schemas/vendedor";

import AText from "@components/atoms/a-text.vue";
import formFactory from "../forms/form-factory-consultaCobertura.vue";

// const builder = new Builder();
export default {
  name: "PageConsultaCobertura",
  components: {
    FormConsultaCobertura: null,
    AText,
  },
  created() {
    const form = new Builder()
      .withProvider(Provider)
      .changeFormFactory(formFactory);

    if (this.$store.getters.sellerMode) {
      form.addField(leadSource).addField(vendedor);
    }

    form
      .addField(telefone)
      .addField(cep)
      .addField(numero);

    this.$options.components.FormConsultaCobertura = form.build();
  },
  mounted() {
    this.$tracking.send();
  },
};
</script>

<template>
  <div>
    <div class="md:px-4 md:max-w-5xl w-full md:mx-auto">
      <a-text tag="h1" class="mb-6">
        Olá! Informe os dados abaixo para consultar a viabilidade do plano
        escolhido :)
      </a-text>
      <form-consulta-cobertura
        class="grid grid-cols-1 md:grid-cols-3 md:col-gap-4"
      />
    </div>
  </div>
</template>

<style>
@media (min-width: theme("screens.md")) {
  .leadSource {
    @apply col-start-1 col-end-2;
  }
  .telefone,
  .numero,
  .cep {
    @apply row-start-2;
  }
}
</style>
